import React from 'react';
import Header from '../Components/Header';
import Main from '../Components/Main';

const Home = () => {
    return (
        <div className="container">
            <Header />
            <Main />
        </div>
    )
}

export default Home;